import { endpoints } from "../../configs/Settings";
import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";

interface IRevokeProps {
  cpf: string;
}

export async function GetSignUser({ cpf }: IRevokeProps) {
  const url = `${endpoints.DSIG}/getUserSessionInfo/${cpf}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
  };
  const response = await useAxios
    ?.get(url, { headers, timeout: 8000 })
    ?.then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
  if (response) return response;
}
